<template>
  <div>
    <core-modal-header>Save Template with Dynamic Text?</core-modal-header>

    <core-modal-body>
      <p v-if="message" v-html="message" />
    </core-modal-body>

    <core-modal-footer>
      <u-button size="xl" color="charcoal" variant="soft" @click="modal.close()">Cancel</u-button>
      <u-button size="xl" color="charcoal" @click="saveAsIs">Save as is</u-button>
      <u-button size="xl" color="red" @click="makeDynamic">Make Dynamic</u-button>
    </core-modal-footer>
  </div>
</template>

<script setup>
  const emit = defineEmits(['make-dynamic', 'save-as-is']);

  const props = defineProps({
    message: String,
    modal: Object
  });

  function makeDynamic() {
    emit('make-dynamic');
  }

  function saveAsIs() {
    emit('save-as-is');
  }
</script>
